export default "__VITE_ASSET__t51cSwS5__"